import { loadTasks, summarizeProjects, type ProjectSummary, type Task } from '@nexus/workspace';
import { useStoreQuery } from './context';

/** All tasks, refreshed when task content, properties or pages change. */
export function useTasks(): Task[] | undefined {
  return useStoreQuery((s) => loadTasks(s), [], ['tasks', 'props', 'pages']);
}

export function useProjects(): { projects: ProjectSummary[]; tasks: Task[] } | undefined {
  return useStoreQuery(
    async (s) => {
      const tasks = await loadTasks(s);
      return { projects: summarizeProjects(await s.listPagesWithProps(), tasks), tasks };
    },
    [],
    ['tasks', 'props', 'pages'],
  );
}
